// extracted by mini-css-extract-plugin
export default {"titleTag":"titleTag___EBhhe","listCrossGroupItems":"listCrossGroupItems___fbT_b"};